import { DESIGN_SYSTEM_THEME } from '../../../../constants/config'

export default {
  baseStyle: {
    rounded: 'lg',
    py: 2,
    px: 4,
    width: 'full',
    _text: {
      fontSize: 'xs',
    },
  },
  defaultProps: {
    variant: DESIGN_SYSTEM_THEME === 'prosperia' ? 'left-accent' : 'solid',
  },
  variants: {
    'left-accent': (props: Record<string, unknown>) => {
      const scheme = props.status ?? props.colorScheme
      return {
        borderLeftWidth: 2,
        _light: {
          bg: `${scheme}.100`,
          _icon: { color: `${scheme}.500` },
          borderLeftColor: `${scheme}.500`,
        },
      }
    },
    solid: (props: Record<string, unknown>) => {
      const scheme = props.status ?? props.colorScheme
      return {
        _light: {
          bg: `${scheme}.100`,
          _icon: { color: `${scheme}.500` },
        },
      }
    },
  },
}
